import { store } from '../../../../redux/store';
import { profileLinks } from '../../../../modules/brand/routes';

/**
 * Where Zap Automations' links go. Creators use it at /influencer/zap/automations;
 * brands open the same page from Profile at /brand/zap/automations (as the
 * app's brand Zap Automations reuses the creator screen), so their plan page
 * and "back" are on the brand side.
 *
 * Plan opens the page the Profile's Subscription row opens (profileLinks). An
 * agency works for the brand it picked (/switch/user puts that brand's ids on
 * UserData), so its Zap — Instagram, automations, plan — is that brand's, and
 * Plan opens that brand's own plans (the brand's Subscription page).
 */
export function zapPaths() {
  const brand = window.location.pathname.startsWith('/brand/');
  const user = (store.getState() as any)?.UserReducer?.UserData;
  // Same rule as the Profile page (useBrandUser).
  const agency = String(user?.account_type || '').toLowerCase() === 'agency';
  return {
    subscription: brand
      ? profileLinks(agency ? 'Agency' : 'Brand', user?.brand_id).subscription
      : '/influencer/settings/subscription',
    back: brand ? '/brand/profile' : '/influencer/zap',
    automations: brand ? '/brand/zap/automations' : '/influencer/zap/automations',
  };
}
